<div class="layout-column settings-audit-log-container">
  <!-- Header -->
  <div class="layout-row layout-align-start-center page-header">
    <h1 translate>Audit Log</h1>
  </div>

  <!-- Filters Toolbar -->
  <div class="layout-row layout-align-start-center filter-toolbar">
    <!-- Action Dropdown Select -->
    <div class="filter-item select-wrapper">
      <app-bringoz-select [options]="actionFilterOptions"
                          [selectedValue]="selectedActionFilter"
                          [placeholder]="'By action'"
                          (onValueChange)="onActionFilterChange($event)">
        <ng-template #ngLabelTmp>
          {{ 'SETTINGS_AUDIT_LOG.ACTION_' + selectedActionFilter | translate }}
        </ng-template>
        <ng-template #ngOptionTmp let-item>
          {{ 'SETTINGS_AUDIT_LOG.ACTION_' + item | translate }}
        </ng-template>
      </app-bringoz-select>
    </div>

    <!-- Status Dropdown Select -->
    <div class="filter-item select-wrapper">
      <app-bringoz-select [options]="statusFilterOptions"
                          [selectedValue]="selectedStatusFilter"
                          [placeholder]="'By status'"
                          (onValueChange)="onStatusFilterChange($event)">
        <ng-template #ngLabelTmp>
          {{ 'SETTINGS_AUDIT_LOG.STATUS_' + selectedStatusFilter | translate }}
        </ng-template>
        <ng-template #ngOptionTmp let-item>
          {{ 'SETTINGS_AUDIT_LOG.STATUS_' + item | translate }}
        </ng-template>
      </app-bringoz-select>
    </div>

    <!-- Date Range Selection -->
    <div class="filter-item date-range-item">
      <app-bringoz-date-range-picker [selectedRange]="selectedRange"
                                     [customTemplates]="customTemplates"
                                     (onChange)="onRangeChange($event)">
      </app-bringoz-date-range-picker>
    </div>
  </div>

  <!-- Main Table View -->
  <div class="table-container flex layout-column" style="overflow: hidden;">

    <!-- Table Skeleton, shown only until the records have loaded for the first time -->
    <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton fade-element-in-only">
      <div class="layout-row layout-align-start-center tr-header">
        <div class="th col-details"></div>
        <div class="th col-timestamp"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-actor"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-action"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-domain"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-status"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
        <div class="th col-description"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      </div>

      <div class="layout-row layout-align-start-center tr" *ngFor="let row of skeletonRows">
        <div class="td col-details"></div>
        <div class="td col-timestamp"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div></div>
        <div class="td col-actor"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div></div>
        <div class="td col-action"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 80%"></div></div>
        <div class="td col-domain"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div></div>
        <div class="td col-status"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div></div>
        <div class="td col-description"><div class="bringoz-skeleton bringoz-skeleton-text" style="width: 85%"></div></div>
      </div>
    </div>

    <!-- Table -->
    <app-bringoz-data-table *ngIf="isInitialized"
                            class="flex layout-column"
                            [uniqueId]="tableUniqueId"
                            [defaultWidths]="defaultWidths"
                            [items]="records"
                            [rowHeight]="rowHeight"
                            [resizable]="true"
                            [isLoading]="isLoading"
                            (fetchNext)="onFetchNext()">

      <ng-template tableHeader>
        <div class="th col-details"></div>
        <div class="th col-timestamp text-ellipsis">{{ 'Timestamp' | translate }}</div>
        <div class="th col-actor text-ellipsis">{{ 'Actor' | translate }}</div>
        <div class="th col-action text-ellipsis">{{ 'Action' | translate }}</div>
        <div class="th col-domain text-ellipsis">{{ 'Domain' | translate }}</div>
        <div class="th col-status text-ellipsis">{{ 'Status' | translate }}</div>
        <div class="th col-description text-ellipsis">{{ 'Description' | translate }}</div>
      </ng-template>

      <ng-template tableRow let-record>
        <div class="tr layout-row layout-align-start-center item">
          <div class="td col-details layout-row layout-align-center-center">
            <button class="details-btn" (click)="openDetail(record)">
              <bringoz-icon iconName="info-outline"></bringoz-icon>
            </button>
          </div>
          <div class="td col-timestamp text-ellipsis">{{ record.formattedDate }}</div>
          <div class="td col-actor text-ellipsis">{{ record.actor || ('Unknown' | translate) }}</div>
          <div class="td col-action text-ellipsis">{{ 'SETTINGS_AUDIT_LOG.ACTION_' + record.action | translate }}</div>
          <div class="td col-domain text-ellipsis">{{ record.domain }}</div>
          <div class="td col-status layout-row layout-align-start-center">
            <span *ngIf="record.status === AuditLogStatus.Success" class="status-tag success">{{ 'SETTINGS_AUDIT_LOG.STATUS_SUCCESS' | translate }}</span>
            <span *ngIf="record.status === AuditLogStatus.Failed" class="status-tag failure">{{ 'SETTINGS_AUDIT_LOG.STATUS_FAILURE' | translate }}</span>
            <span *ngIf="record.status !== AuditLogStatus.Success && record.status !== AuditLogStatus.Failed" class="status-tag default">{{ record.status || '-----' }}</span>
          </div>
          <div class="td col-description text-ellipsis">
            <ng-container *ngIf="record.rawRecord.metadata?.keys as settingKey; else noSettingDescription">
              {{ 'SETTINGS_AUDIT_LOG.DESCRIPTION_' + record.action | translate: {setting: settingKey} }}
            </ng-container>
            <ng-template #noSettingDescription>---</ng-template>
            <span *ngIf="record.rawRecord.reason"> — {{ record.rawRecord.reason }}</span>
          </div>
        </div>
      </ng-template>

      <app-empty-state tableEmptyState
                       src="assets/images/empty_state/empty_state_history.png"
                       text="No audit records found">
      </app-empty-state>

    </app-bringoz-data-table>
  </div>

  <!-- Loading indicator - only for page/filter fetches once the first load has already painted -->
  <app-bringoz-linear-progress *ngIf="isLoading && isInitialized"></app-bringoz-linear-progress>
</div>
